import React, { Fragment, useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import classnames from 'classnames';
import cn from 'classnames';
import _range from 'lodash/range';

import { importStatic } from 'utils';

import classes from './index.module.css';

export interface Props {
  withRateTip?: boolean;
  customClasses?: {
    star?: string;
    container?: string;
  };
  starLoop?: number;
  disabled?: boolean;
  fullSvgSrc?: string;
  halfSvgSrc?: string;
  ratingIndex?: number;
  onRate?(value: number): void;
  hasError?: boolean;
  smallStar?: boolean;
  colorClass?: string;
  showTitle?: boolean;
  injectedContainerClass?: string;
  injectedStarClass?: string;
}

const STAR_TITLES = ['Poor', 'Fair', 'Good', 'Excellent', 'WOW!!!'];

const Ratings = ({
  withRateTip,
  customClasses,
  starLoop,
  disabled,
  fullSvgSrc,
  halfSvgSrc,
  ratingIndex,
  onRate,
  hasError,
  smallStar = false,
  colorClass = 'green',
  showTitle = true,
  injectedContainerClass = '',
  injectedStarClass = '',
}: Props) => {
  const [rate, setRate] = useState<number>();
  const [modulo, setModulo] = useState<number>();
  const [isRateTipGreen, setIsRateTipGreen] = useState(false);
  useEffect(() => {
    if (![undefined, null].includes(ratingIndex) && ratingIndex >= 0) {
      const rating = ratingIndex + 1;
      setModulo(rating % 1);
      setRate(rating && Math.floor(rating));
    }
  }, [ratingIndex]);

  const { star: customStarClass, container: customContainerClass } = customClasses;
  useEffect(() => {
    if (withRateTip) {
      setIsRateTipGreen(customStarClass === 'emptyStar');
    }
  }, [withRateTip, customStarClass]);

  const ratingIcon = (value) => {
    let ratingIconClasses = [customStarClass ? classes[customStarClass] : classes.star];
    let svgSrc = fullSvgSrc;
    if (rate === value && modulo && modulo <= 0.5) {
      svgSrc = halfSvgSrc;
      ratingIconClasses = ratingIconClasses.concat(classes.halfStar);
    } else if ((rate === value && modulo && modulo > 0.5) || (rate >= value + 1 && rate != null)) {
      ratingIconClasses = ratingIconClasses.concat(classes.fullStar);
    }
    if (smallStar) {
      ratingIconClasses = ratingIconClasses.concat(classes.smallStar);
    }
    if (injectedStarClass) {
      ratingIconClasses = ratingIconClasses.concat(injectedStarClass);
    }
    return (
      <div
        className={classnames(
          classes.starWrapper,
          classes[colorClass], {
          [classes['smallStarWrapper']]: smallStar,
          ['pointer']: !disabled
        }
        )}
      >
        <ReactSVG className={ratingIconClasses.join(' ')} src={svgSrc} title={showTitle ? STAR_TITLES[value] : ''} />
      </div>
    );
  };

  const ratingClickable = (value) => (
    <div
      onClick={() => {
        onRate(value);
      }}
      className={classnames(classes['ratingIcon'], value <= ratingIndex ? classes['active'] : '')}
    >
      {ratingIcon(value)}
    </div>
  );

  return (
    <div
      className={cn(
        classes.starsContainer,
        { [classes[customContainerClass]]: customContainerClass },
        { [classes.hasError]: hasError },
        injectedContainerClass
      )}
    >
      {_range(0, starLoop).map((value) => (
        <Fragment key={value}>
          {disabled && ratingIcon(value)}
          {!disabled && ratingClickable(value)}
        </Fragment>
      ))}
      {withRateTip && (
        <ReactSVG
          src={`/ui-router/images/${isRateTipGreen ? 'rate-box.svg' : 'rate-box-unfocus.svg'}`}
        />
      )}
    </div>
  );
};

Ratings.defaultProps = {
  withRateTip: false,
  customClasses: {},
  starLoop: 5,
  disabled: false,
  fullSvgSrc: importStatic('/ui-router/images/star.svg'),
  halfSvgSrc: importStatic('/ui-router/images/star-half.svg'),
  ratingIndex: null,
  onRate: () => null,
  hasError: false,
  showTitle: true
};

export { Ratings };

export default Ratings;
